__turbopack_context__.v({
  "bottom-subtext": "RegistrationForm-module-sass-module__y7__jW__bottom-subtext",
  "buttons-row": "RegistrationForm-module-sass-module__y7__jW__buttons-row",
  "card-big": "RegistrationForm-module-sass-module__y7__jW__card-big",
  "card-flex": "RegistrationForm-module-sass-module__y7__jW__card-flex",
  "card-title": "RegistrationForm-module-sass-module__y7__jW__card-title",
  "checkbox-line": "RegistrationForm-module-sass-module__y7__jW__checkbox-line",
  "content": "RegistrationForm-module-sass-module__y7__jW__content",
  "desktop-bottom-line": "RegistrationForm-module-sass-module__y7__jW__desktop-bottom-line",
  "form": "RegistrationForm-module-sass-module__y7__jW__form",
  "gap": "RegistrationForm-module-sass-module__y7__jW__gap",
  "gap-6": "RegistrationForm-module-sass-module__y7__jW__gap-6",
  "link": "RegistrationForm-module-sass-module__y7__jW__link",
  "local-title": "RegistrationForm-module-sass-module__y7__jW__local-title",
  "more-button": "RegistrationForm-module-sass-module__y7__jW__more-button",
  "next-button": "RegistrationForm-module-sass-module__y7__jW__next-button",
  "prev-button": "RegistrationForm-module-sass-module__y7__jW__prev-button",
  "pro": "RegistrationForm-module-sass-module__y7__jW__pro",
  "promo-block": "RegistrationForm-module-sass-module__y7__jW__promo-block",
  "promo-block-column": "RegistrationForm-module-sass-module__y7__jW__promo-block-column",
  "promo-card-row": "RegistrationForm-module-sass-module__y7__jW__promo-card-row",
  "promo-group": "RegistrationForm-module-sass-module__y7__jW__promo-group",
  "red": "RegistrationForm-module-sass-module__y7__jW__red",
  "row": "RegistrationForm-module-sass-module__y7__jW__row",
  "submit-block": "RegistrationForm-module-sass-module__y7__jW__submit-block",
  "subtext": "RegistrationForm-module-sass-module__y7__jW__subtext",
  "survey": "RegistrationForm-module-sass-module__y7__jW__survey",
  "text-align-center": "RegistrationForm-module-sass-module__y7__jW__text-align-center",
  "title": "RegistrationForm-module-sass-module__y7__jW__title",
  "total": "RegistrationForm-module-sass-module__y7__jW__total",
  "total-description": "RegistrationForm-module-sass-module__y7__jW__total-description",
  "total-group": "RegistrationForm-module-sass-module__y7__jW__total-group",
  "weird-icon-button": "RegistrationForm-module-sass-module__y7__jW__weird-icon-button",
});
